
import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const RenewAverageDaysPage = lazy(() => import('./RenewAverageDaysPage'));
const path = 'reports/average-days-renewal';
const RenewAverageDaysRoute: FuseRouteItemType = {
	path: path,
	element: <RenewAverageDaysPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Average Days to Renewal',
					helpName: 'Average Days to Renewal',
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default RenewAverageDaysRoute;
